/**
 * PublicLayout Component
 * Layout wrapper for public-facing pages with shared header
 */

import { ReactNode } from 'react';
import { PublicHeader } from './PublicHeader';
import { NavItem, INVEST_NAV_ITEMS } from './navConfig';

interface PublicLayoutProps {
  children: ReactNode;
  navItems?: NavItem[];
  activeSection?: string;
  onScrollToSection?: (id: string) => void;
  className?: string;
}

export const PublicLayout = ({
  children,
  navItems = INVEST_NAV_ITEMS,
  activeSection,
  onScrollToSection,
  className = '',
}: PublicLayoutProps) => {
  return (
    <div className={`min-h-screen bg-white ${className}`}>
      <PublicHeader
        navItems={navItems}
        activeSection={activeSection}
        onScrollToSection={onScrollToSection}
      />
      {children}
    </div>
  );
};
